import React from 'react';
import { Box, useMediaQuery } from '@material-ui/core';
import {
    FrequenceDureeTerme,
    FrequenceRemboursement,
    SousTypeTaux,
    TypeAssurance,
    TypeOffreTarification,
    TypeTaux,
    isVariableProtege,
    TypeOffre,
    TypeOffreParams
} from '../../../../hooks';
import { GridCol } from '../../../../styles';
import { Card } from '../card/Card';
import {
    getIsBottomCard,
    getIsTitreSurDeuxLigne,
    getIsVoisinTitreSurDeuxLigne,
    getNbTagVoisin
} from './CardList.util';

export interface ICard {
    idOffre: number;
    idDemande: number;
    offerTitle: string;
    primeRate: number;
    effectiveRate: number;
    ceilingRate: number;
    hasPrimeNote: boolean;
    interestRate: number;
    tauxRabaisSubsequent: number;
    hasInterestNote: boolean;
    paiement: number;
    frequence: FrequenceRemboursement;
    showVariableProtegeInterestNote: boolean;
    typeOffreTarification: TypeOffreTarification;
    isOffreSelectionnee: boolean;
    typeTaux: TypeTaux;
    sousTypeTaux: SousTypeTaux;
    typeOffre: TypeOffre;
    isDisabled: boolean;
    valeurDureeTerme: number;
    frequenceDureeTerme: FrequenceDureeTerme;
}

interface CardListProps {
    isCoemprunteur: boolean;
    typeAssurance: TypeAssurance;
    cardList: ICard[];
    onOfferSelected: (
        idDemande: number,
        idOffre: number,
        isOfferVariableProtege: boolean,
        tauxPropose: number
    ) => void;
}

export const CardList: React.FC<CardListProps> = ({
    isCoemprunteur,
    typeAssurance,
    cardList,
    onOfferSelected
}) => {
    const isTablet = useMediaQuery('(max-width:991px)');
    const isEcranSmall = useMediaQuery('(max-width:1200px)'); // utilise pour carte offre
    const isEcranMedium = useMediaQuery('(max-width:1440px)'); // utilise pour carte offre

    return (
        <Box display="flex" flexWrap="wrap" margin="0 -12px">
            {cardList &&
                cardList.map((offre, key) => {
                    const typeOffreParams: TypeOffreParams = {
                        typeTaux: offre.typeTaux,
                        sousTypeTaux: offre.sousTypeTaux
                    };
                    const isOfferVariableProtege =
                        isVariableProtege(typeOffreParams);
                    return (
                        <GridCol
                            col="12"
                            sm="12"
                            md="6"
                            key={key}
                            dataTestId={String(offre.idOffre)}
                        >
                            <Card
                                offre={offre}
                                isCoemprunteur={isCoemprunteur}
                                typeAssurance={typeAssurance}
                                isBottomCard={getIsBottomCard(
                                    cardList,
                                    offre,
                                    isTablet
                                )}
                                isTitreSurDeuxLigne={getIsTitreSurDeuxLigne(
                                    offre?.typeOffre,
                                    isEcranSmall,
                                    isEcranMedium
                                )}
                                nbTagVoisin={getNbTagVoisin(cardList, offre)}
                                isVoisinTitreSurDeuxLigne={getIsVoisinTitreSurDeuxLigne(
                                    cardList,
                                    offre,
                                    isEcranSmall,
                                    isEcranMedium
                                )}
                                onSelectOffer={() => {
                                    onOfferSelected(
                                        offre.idDemande,
                                        offre.idOffre,
                                        isOfferVariableProtege,
                                        offre.interestRate
                                    );
                                }}
                            />
                        </GridCol>
                    );
                })}
        </Box>
    );
};
